import BaseApi from "../baseApi";
import { USER } from "../apiConstant";

class UserApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_AUTHENTICATION_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }
  checkExistedUser(param) {
    return this.get(`${USER}/existed-user/${param}`);
  }

  getMe() {
    return this.get(`${USER}/getMe`);
  }

  logout(param) {
    return this.post(`${USER}/logout`, param);
  }

  listPerson(param) {
    return this.post(`${USER}/list`, param);
  }

  getFriend(param) {
    return this.post(`${USER}/friend/${param}`);
  }

  getByEmail(param) {
    return this.post(`${USER}/find`, param);
  }

  upload(file) {
    return this.post(`${USER}/upload-profile-image`, file);
  }

  remove(file) {
    return this.post(`${USER}/remove-profile-image`, file);
  }

  saveMe(param) {
    return this.post(`${USER}/save-me`, param);
  }

  getUserList(param) {
    return this.post(`${USER}/admin/page`, param);
  }

  getUser(param, signal) {
    return this.post(`${USER}/friend/${param}`, null, signal);
  }

  createUser(param) {
    return this.post(`${USER}/admin/create`, param);
  }

  updateUser(param) {
    return this.post(`${USER}/admin/update`, param);
  }

  removeUser(param) {
    return this.post(`${USER}/admin/remove/${param}`);
  }

  resetPassword(param) {
    return this.post(`${USER}/admin/reset-password/${param}`);
  }

  orgUser(param) {
    return this.get(`${USER}/org-user/${param}`);
  }

  listUserById(params) {
    return this.post(`${USER}/info-user-list`, params);
  }
}
export default UserApi;
